module.exports = __webpack_public_path__ + "static/img/application9-4.58ded4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application9-4.jpg
// module id = Uv/0
// module chunks = 0